import { Stack } from '@mui/material';

import { CardBrand } from '~types/pricing.type';

const SUPPORTED_CARDS = [
  {
    name: 'visa',
    image: '/images/card-icons/visa.svg',
  },
  {
    name: 'mastercard',
    image: '/images/card-icons/mastercard.svg',
  },
  {
    name: 'amex',
    image: '/images/card-icons/america_express.svg',
  },
  {
    name: 'discover',
    image: '/images/card-icons/discover.svg',
  },
];

export const ListSupportedCards = ({ cardBrand }: { cardBrand: CardBrand }) => {
  return (
    <Stack direction="row" spacing={2}>
      {SUPPORTED_CARDS.map((card) => (
        <img
          key={card.name}
          src={card.image}
          alt={card.name}
          width={24}
          height={24}
          style={{
            opacity:
              cardBrand === card.name || cardBrand === 'unknown' ? 1 : 0.5,
          }}
        />
      ))}
    </Stack>
  );
};
